import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, catchError, tap } from 'rxjs/operators';
import { Subscription, EMPTY, Observable, fromEvent } from 'rxjs';
import { SmoochService } from 'src/app/services/smooch.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-retention',
  templateUrl: './retention.component.html',
  styleUrls: ['./retention.component.scss']
})
export class RetentionComponent implements OnInit, OnDestroy, AfterViewInit{

  @ViewChild('btnSave', { read: ElementRef }) btnSave: ElementRef;
  @ViewChild('retentionHours') retentionHours: ElementRef;
  retention: number;
 
  constructor(
    private _smoochService: SmoochService,
    private _snackBar: MatSnackBar
  )
  {
  }


  ngAfterViewInit(): void {

    this._subscription = fromEvent(this.btnSave.nativeElement, 'click').pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap(form => {
        if (!this.retentionFormGroup.valid) {
          return EMPTY;
        }
        return this.updateRetention(this.retentionHours.nativeElement.value);
      })
    ).subscribe();
  }


  private _subscription: Subscription;
  retentionFormGroup: FormGroup;

  ngOnInit(): void {

    this.retentionFormGroup = new FormGroup({
      hours: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]+$'),
      ])
    });

    this.getRetention();
}

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }


  private updateRetention(retentionHours: number): Observable<number> {
    return this._smoochService.updateRetention(retentionHours).pipe(
      tap(() => {
        this._snackBar.open(`Updated retention to ${retentionHours} hours.`);
      }),
      catchError((error) => {
        this._snackBar.open(`Failed to update retention to ${retentionHours} hours.  ${error.error.description}`);
        return EMPTY;
      })
    );
  }

  private getRetention(): void {

    this._smoochService.getRetention()
      .then(res => {
        this.retention = res;
      }).catch(error => {
        this._snackBar.open(`Failed to get retention.  ${error.error.description}`);
      });
  }

}
